const FLAG_KEY = 'hf_admin_enter'
const PROMPTED_KEY = 'hf_admin_enter_prompted'
const BANNER_DISMISSED_KEY = 'hf_admin_enter_banner_dismissed'
const EMAIL_KEY = 'hf_admin_enter_email'

export function markAdminEnter(email) {
  try {
    sessionStorage.setItem(FLAG_KEY, '1')
    sessionStorage.removeItem(PROMPTED_KEY)
    sessionStorage.removeItem(BANNER_DISMISSED_KEY)
    setAdminEnterEmail(email)
  } catch (e) {
    // ignore
  }
}

export function setAdminEnterEmail(email) {
  try {
    const value = email && String(email).trim()
    if (value) {
      sessionStorage.setItem(EMAIL_KEY, value)
    }
  } catch (e) {
    // ignore
  }
}

export function getAdminEnterEmail() {
  try {
    return sessionStorage.getItem(EMAIL_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function getManageOrigin() {
  const {protocol, hostname} = window.location
  if (hostname === 'app.honestfulphilment.com') {
    return 'https://manage.honestfulphilment.com'
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:7080`
  }
  if (hostname.startsWith('app.')) {
    return `${protocol}//${hostname.replace(/^app\./, 'manage.')}`
  }
  return `${protocol}//manage.${hostname}`
}

export function buildManageUserListUrl(email) {
  const qs = email ? `?email=${encodeURIComponent(email)}` : ''
  return `${getManageOrigin()}/user/index${qs}`
}

export function clearAdminEnter() {
  try {
    sessionStorage.removeItem(FLAG_KEY)
    sessionStorage.removeItem(PROMPTED_KEY)
    sessionStorage.removeItem(BANNER_DISMISSED_KEY)
    sessionStorage.removeItem(EMAIL_KEY)
  } catch (e) {
    // ignore
  }
}

export function isAdminEnter() {
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1'
  } catch (e) {
    return false
  }
}

export function isAdminEnterBannerVisible() {
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1'
      && sessionStorage.getItem(BANNER_DISMISSED_KEY) !== '1'
  } catch (e) {
    return false
  }
}

export function dismissAdminEnterBanner() {
  try {
    sessionStorage.setItem(BANNER_DISMISSED_KEY, '1')
  } catch (e) {
    // ignore
  }
}

export function shouldPromptAdminEnter() {
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1'
      && sessionStorage.getItem(PROMPTED_KEY) !== '1'
  } catch (e) {
    return false
  }
}

export function markAdminEnterPrompted() {
  try {
    sessionStorage.setItem(PROMPTED_KEY, '1')
  } catch (e) {
    // ignore
  }
}
